export const EDIT_POST_PAGE_TITLE = 'edit-post-page.title';
export const EDIT_POST_PAGE_SUBMIT_BUTTON_LABEL = 'edit-post-page.submit-button-label';
